import React from "react";
import { useSelector } from "react-redux";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { CircularProgress } from "@material-ui/core";

const StepperButton = ({
  steps,
  activeStep,
  handleReset,
  getStepContent,
  isStepOptional,
  handleSkip,
  classes,
  handleBack,
  handleNext,
  handleSubmit,
  buttonDisabled,
}) => {
  const language = useSelector((state) => state.store.language);

  return (
    <div
      style={{
        backgroundColor: "white",
        paddingBottom: 8,
        marginBottom: 0,
        height: 65,
        zIndex: 4,
        alignItems: "center",
        display: "flex",
        direction: language === "english" ? "ltr" : "rtl",
        paddingLeft: 10,
        paddingRight: 10,
      }}
      className={
        language === "english"
          ? "action-button-english bordered"
          : "action-button-arabic bordered"
      }
    >
      <div
        style={{
          width: "100%",
          display: "grid",
          gridTemplateRows: "1fr",
          gridAutoFlow: "column",
        }}
      >
        <Button
          variant={"outlined"}
          disabled={activeStep === 0}
          onClick={handleBack}
          className={classes.button}
        >
          {language === "english" ? "Back" : "عودة"}
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={buttonDisabled}
          onClick={activeStep === steps.length - 1 ? handleSubmit : handleNext}
          className={classes.button}
        >
          {buttonDisabled ? (
            <CircularProgress size={24} color="inherit" /> // Spinner when loading
          ) : activeStep === steps.length - 1 ? (
            language === "english" ? (
              "Submit"
            ) : (
              "إرسال"
            )
          ) : language === "english" ? (
            "Next"
          ) : (
            "التالي"
          )}
        </Button>
      </div>
    </div>
  );
};

export default StepperButton;
